












































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import { getProductListByPage } from "@/axios";

import { AppModule } from "@/store/app";

@Component({
  name: "landmarkShop",
})
export default class extends Vue {
  @Prop()
  inputLandmarkShopData: any;

  private landmarkShopData: any = {
    cityList: [],
    enterpriseGoodsArray: [],
    goodsGroupArray: [],
    advertisementArray: [],
  };

  private enterpriseGoodsArray: any = [];

  private cityItemIndex: any = 0;

  private citySelected: any = "";

  private landmarkId: any = "";

  private img: any = [
    {
      id: 1,
      name: "test",
      url: require("../assets/images/fuguoing1.png"),
    },
    {
      id: 2,
      name: "test",
      url: require("../assets/images/fuguoing2.png"),
    },
    {
      id: 3,
      name: "test",
      url: require("../assets/images/fuguoing5.png"),
    },
    {
      id: 4,
      name: "test",
      url: require("../assets/images/fuguoing4.png"),
    },
    {
      id: 5,
      name: "test",
      url: require("../assets/images/fuguoing3.png"),
    },
  ];

  @Watch("inputLandmarkShopData", { immediate: true, deep: true })
  oninputLandmarkShopData(val: any, oldVal: any) {
    if (val) {
      this.landmarkShopData = val;
      // this.enterpriseGoodsArray = val.enterpriseGoodsArray;
      this.listCount = val.enterpriseGoodsCount;
      this.area_id = val.goodsGroupArray[0].id;
      console.log(" this.enterpriseGoodsArray", this.enterpriseGoodsArray);

      // this.getData();
    }
  }

  created() {
    this.landmarkId = this.$route.query.landmarkId;
  }
  mounted() {
    if (AppModule.landMarkId) {
      this.area_id = AppModule.landMarkId;
    }
    AppModule.landMarkIdAc(null);
    this.getData();
  }

  private tabCityItemIndex(index: any, id: any) {
    this.area_id = id;
    this.cityItemIndex = index;
    this.page = 1;
    this.getData();
  }

  private page: any = 1;
  private page_size: any = 9;
  private area_id: any = "";
  private listCount: any = 0;

  private pageChange(page: any) {
    this.page = page;
    this.getData();
  }

  private openUrl(url: any) {
    if (url) {
      window.open(url, "_blank");
    }
  }
  private searchshopevent() {
    getProductListByPage({
      page_size: this.page_size,
      page: this.page,
      group_id: this.area_id,
      landmark_id: this.landmarkId,
      searchName: this.searchName,
    }).then((res: any) => {
      this.listCount = res.data.data.count;
      this.enterpriseGoodsArray = res.data.data.data;
      // console.log('getProductListByPage----------',res)
    });
  }

  private searchName: any = "";
  private getData() {
    getProductListByPage({
      page_size: this.page_size,
      page: this.page,
      group_id: this.area_id,
      landmark_id: this.landmarkId,
      searchName: this.searchName,
    }).then((res: any) => {
      this.listCount = res.data.data.count;
      this.enterpriseGoodsArray = res.data.data.data;
      // console.log('getProductListByPage----------',res)
    });
  }
}
